// extracted by mini-css-extract-plugin
export var defaultWrapper = "_nl-3";
export var downloadButton = "_nl-4";
export var fileContainer = "_nl-9 _nl-7";
export var fileContainerBase = "_nl-7";
export var fileContainerFixedHeight = "_nl-8 _nl-7";
export var fileInfo = "_nl-5";
export var fileInfoWidthRestricted = "_nl-6";
export var fileType = "_nl-1";
export var fileTypeName = "_nl-2";
export var image = "_nl-0";
export var link = "_nl-b";
export var overflowEllipsis = "_nl-a";